import { useCallback, useMemo } from 'react'
import OfferBreadcrumbTrail from 'components/OfferPage/RelatedTravelItems/OfferBreadcrumbTrail'
import type { OfferClickSearchParams } from 'tripPlanner/assistant/contexts/ChatMessageActionsContext'
import { useTripPlannerEventBusOptional } from 'tripPlanner/assistant/contexts/TripPlannerEventBus'

export interface OfferDetailBreadcrumbPlace {
  name: string
  country?: string
  /** LE place id, when the trail resolved one. Without it the listing drawer
   *  it opens has only the name to search on. */
  placeId?: string
}

export interface OfferDetailBreadcrumb {
  text: string
  /**
   * The place this crumb narrows to. A crumb without one is not actionable:
   * the leading vertical ("Hotels") has no trip planner surface of its own,
   * and the trailing crumb is the offer whose drawer is already open.
   */
  place?: OfferDetailBreadcrumbPlace
}

interface Props {
  items: Array<OfferDetailBreadcrumb>
  vertical: 'hotel' | 'experience'
  searchParams?: OfferClickSearchParams
}

function OfferDetailBreadcrumbs({ items, vertical, searchParams }: Props) {
  const eventBus = useTripPlannerEventBusOptional()

  const handleSelectPlace = useCallback((index: number) => {
    const place = items[index]?.place
    if (!place) return

    eventBus?.dispatch({
      type: 'open_listing_search_drawer',
      vertical,
      placeName: place.name,
      placeCountry: place.country,
      placeId: place.placeId,
      searchParams,
    })
  }, [eventBus, items, vertical, searchParams])

  const trailItems = useMemo(() => items.map(item => ({
    text: item.text,
    actionable: !!item.place,
  })), [items])

  return <OfferBreadcrumbTrail items={trailItems} onSelect={handleSelectPlace} />
}

export default OfferDetailBreadcrumbs
